import { isTruthyEnvFlag } from '@/lib/utils/env-flags';

export type RuntimeFlagValue = string | number | boolean | null | undefined;

export interface RuntimeModeSnapshot {
  readonly isApiMockRuntime: boolean;
  readonly isAutomationRuntime: boolean;
  readonly isBuildPhase: boolean;
  readonly isCiRuntime: boolean;
  readonly isMockAuthRuntime: boolean;
  readonly isPlaywrightAuthDebugEnabled: boolean;
  readonly isPlaywrightRuntime: boolean;
}

export interface RuntimeModeEnvLike {
  readonly NEXT_PUBLIC_API_MOCK?: RuntimeFlagValue;
  readonly NEXT_PUBLIC_MSW?: RuntimeFlagValue;
  readonly NEXT_PUBLIC_PLAYWRIGHT_TEST?: RuntimeFlagValue;
  readonly PLAYWRIGHT_AUTH_DEBUG?: RuntimeFlagValue;
  readonly PLAYWRIGHT_MOCK_AUTH?: RuntimeFlagValue;
  readonly PLAYWRIGHT_RUNTIME?: RuntimeFlagValue;
  readonly PLAYWRIGHT_TEST?: RuntimeFlagValue;
  readonly PLAYWRIGHT_TEST_RUNTIME?: RuntimeFlagValue;
}

export interface RuntimeModeSystemEnvLike {
  readonly CI?: string | null;
  readonly GITHUB_ACTIONS?: string | null;
  readonly NEXT_PHASE?: string | null;
}

export function resolveRuntimeModeSnapshot(
  envLike: RuntimeModeEnvLike,
  systemEnvLike: RuntimeModeSystemEnvLike = {}
): RuntimeModeSnapshot {
  const phase = systemEnvLike.NEXT_PHASE?.trim().toLowerCase() ?? null;
  const buildPhase = phase === 'phase-production-build' || phase === 'phase-export';

  const ciRuntime = isTruthyEnvFlag(systemEnvLike.CI) || isTruthyEnvFlag(systemEnvLike.GITHUB_ACTIONS);

  const apiMockRuntime =
    !buildPhase && (isTruthyEnvFlag(envLike.NEXT_PUBLIC_API_MOCK) || isTruthyEnvFlag(envLike.NEXT_PUBLIC_MSW));

  const playwrightRuntime =
    !buildPhase &&
    (isTruthyEnvFlag(envLike.NEXT_PUBLIC_PLAYWRIGHT_TEST) ||
      isTruthyEnvFlag(envLike.PLAYWRIGHT_TEST) ||
      isTruthyEnvFlag(envLike.PLAYWRIGHT_RUNTIME) ||
      isTruthyEnvFlag(envLike.PLAYWRIGHT_TEST_RUNTIME));

  const mockAuthRuntime =
    !buildPhase && (apiMockRuntime || playwrightRuntime || isTruthyEnvFlag(envLike.PLAYWRIGHT_MOCK_AUTH));
  const playwrightAuthDebugEnabled = !buildPhase && isTruthyEnvFlag(envLike.PLAYWRIGHT_AUTH_DEBUG);

  return {
    isBuildPhase: buildPhase,
    isCiRuntime: ciRuntime,
    isApiMockRuntime: apiMockRuntime,
    isPlaywrightRuntime: playwrightRuntime,
    isAutomationRuntime: apiMockRuntime || playwrightRuntime,
    isMockAuthRuntime: mockAuthRuntime,
    isPlaywrightAuthDebugEnabled: playwrightAuthDebugEnabled,
  };
}
